import { Component } from "@angular/core";

@Component({
  selector: 'app-pf-tutorial-list',
  templateUrl: './pf-tutorial-list.component.html',
  styleUrls: ['./pf-tutorial-list.component.scss']
})
export class PfTutorialListComponent {

}